<template lang="pug">
  multiselect(
    :value="value"
    :options="countryList"
    placeholder="Type to search"
    label="Desc_en"
    track-by="Desc_en"
    name="code"
    @input="onInput"
    :disabled="disabled"
    :loading="country_loading"
    :internalSearch="true"
    @search-change="loadCountry"
  )
    template(slot="option" slot-scope="props")
      span.block {{ props.option.Desc_en }}
</template>

<script>
import jsonData from './e-invoice/CountryCodes.json';
import _ from 'lodash';

export default {
    props: {
        value: {
            type: null,
            default: () => null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            countryList: [],
            country_loading: false,
        };
    },
    mounted() {
        this.loadCountry();
    },
    methods: {
        onInput(value) {
            this.$emit('input', value);
        },
        loadCountry: _.debounce(function(query) {
            this.country_loading = true;

            if (query) {
                this.countryList = jsonData.filter(item =>
                    item.Desc_en.toLowerCase().includes(query.toLowerCase()),
                );
            } else {
                this.countryList = jsonData;
            }

            this.country_loading = false;
        }, 500),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/eCountrySelector.vue